import { connect } from 'react-redux';
import { useEffect } from 'react';
import { track } from 'MeetingsLib/tracking/UsageTracker';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import { getMeetingSourceFromLocation } from 'MeetingsLib/utils/utils';
import { H2 } from 'foundations-components/transitional/components/H2';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
// TODO: Function component can use useSelector hook instead of connect
const RescheduleHeader = ({
  eventDetails,
  isRescheduling
}) => {
  useEffect(() => {
    track('meetingEventInteraction', {
      action: 'viewed reschedule',
      source: getMeetingSourceFromLocation()
    });
  }, []);
  if (!isRescheduling) {
    return null;
  }
  return /*#__PURE__*/_jsxs(View, {
    textAlign: "center",
    children: [/*#__PURE__*/_jsx(H2, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reschedule.header"
      })
    }), eventDetails && /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "reschedule.description",
      options: {
        meetingDateTime: /*#__PURE__*/_jsx(FormattedDateTime, {
          value: eventDetails.startTime,
          format: "LLLL"
        })
      }
    })]
  });
};
export default connect(state => ({
  /*  @ts-ignore Jun-18-2025, 19:10UTC fix types  */
  eventDetails: state.eventDetails,
  /*  @ts-ignore Jun-18-2025, 19:10UTC fix types  */
  isRescheduling: state.isRescheduling
}))(RescheduleHeader);